import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "confirmation-dialog-svg-sprite",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">

      <symbol id="trashHeaderTitleIcon" viewBox="0 0 20 20" fill="none">
        <path d="M16.875 4.375H3.125" stroke="#EB3B3B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.125 8.125V13.125" stroke="#EB3B3B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.875 8.125V13.125" stroke="#EB3B3B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.625 4.375V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H5C4.83424 16.875 4.67527 16.8092 4.55806 16.6919C4.44085 16.5747 4.375 16.4158 4.375 16.25V4.375" stroke="#EB3B3B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.125 4.375V3.125C13.125 2.79348 12.9933 2.47554 12.7589 2.24112C12.5245 2.0067 12.2065 1.875 11.875 1.875H8.125C7.79348 1.875 7.47554 2.0067 7.24112 2.24112C7.0067 2.47554 6.875 2.79348 6.875 3.125V4.375" stroke="#EB3B3B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
      </symbol>

      <symbol id="trashConfirmIcon" viewBox="0 0 52 52" fill="none">
        <g clip-path="url(#clip0_512_21)">
          <path d="M43.875 11.375H8.125" stroke="#EC3030" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21.125 21.125V34.125" stroke="#EC3030" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M30.875 21.125V34.125" stroke="#EC3030" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M40.625 11.375V42.25C40.625 42.681 40.4538 43.0943 40.149 43.399C39.8443 43.7038 39.431 43.875 39 43.875H13C12.569 43.875 12.1557 43.7038 11.851 43.399C11.5462 43.0943 11.375 42.681 11.375 42.25V11.375" stroke="#EC3030" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M34.125 11.375V8.125C34.125 7.26305 33.7826 6.4364 33.1731 5.8269C32.5636 5.21741 31.737 4.875 30.875 4.875H21.125C20.263 4.875 19.4364 5.21741 18.8269 5.8269C18.2174 6.4364 17.875 7.26305 17.875 8.125V11.375" stroke="#EC3030" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_512_21">
            <rect width="52" height="52" fill="white"/>
          </clipPath>
        </defs>
      </symbol>

    </svg>
  `,
})
export class ConfirmationDialogSvgSpriteComponent {}
